import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from '../services/navigationService';

/**
 * NavigationSetter - Sets up the navigation service with React Router's navigate
 * 
 * Must be rendered inside BrowserRouter to have access to navigate
 */
const NavigationSetter = () => {
  const navigate = useNavigate();

  useEffect(() => {
    setNavigate(navigate);
  }, [navigate]);

  return null;
};

export default NavigationSetter;
